module.exports = "https://cdn-shared.mathletics.com/teacher-modules/internal-course-manager/44assets/fonts/b06871f281fee6b241d60582ae9369b9.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.7.0
// module id = 794
// module chunks = 4